import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

// const head = { "Content-Type": "multipart/form-data" };
// const instance2 = axios.create({
//   baseURL: apihostname,
//   headers: { ...authHeader(), ...head },
// });

class FactoryService {
  getFactorylist() {
    return instance.get("/factory");
  }
  getContractList(body) {
    return instance.post("/factory/contract", body);
  }
  getFactoryById(id) {
    return instance.get("/factory/" + id);
  }
  createFactory(body) {
    return instance.post("/factory/create", body);
  }
  updateFactory(body) {
    return instance.post("/factory/update", body);
  }
  deleteFactory(factory_id) {
    return instance.delete("/factory/delete/" + factory_id);
  }
  activateFactory(body) {
    return instance.post("/factory/activate", body);
  }
  // Member Manipulate
  validateNewMember(idcard, factory_id) {
    return instance.get("/factory/check/" + idcard + "/" + factory_id);
  }
  createMember(body) {
    return instance.post("/factory/member/new", body);
  }
  updateMember(body) {
    // console.log(body);
    return instance.post("/factory/member/update", body);
  }
  deleteMember(member_id) {
    return instance.delete("/factory/member/delete/" + member_id);
  }
  getSugarcaneProduct() {
    return instance.get("/getsugarcane-products");
  }
}

export default new FactoryService();
